const value = {
    turnIntoQuestion: 'Turn into question',
    removeQuestion: 'Remove question',
    rename: 'Rename',
  };

export default value;
